// extracted by mini-css-extract-plugin
module.exports = {"outerWrapperDark":"layout-module--outer-wrapper-dark--2AWGI","outerWrapperLight":"layout-module--outer-wrapper-light--37kDA","innerWrapper":"layout-module--inner-wrapper--29HyY"};